import { render, staticRenderFns } from "./ImportantMessageCard.vue?vue&type=template&id=53ca4b9a&scoped=true&"
import script from "./ImportantMessageCard.vue?vue&type=script&lang=js&"
export * from "./ImportantMessageCard.vue?vue&type=script&lang=js&"
import style0 from "./ImportantMessageCard.vue?vue&type=style&index=0&id=53ca4b9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ca4b9a",
  null
  
)

export default component.exports